import { forwardRef, JSX } from 'react';

import {
  Corner,
  Root,
  Scrollbar,
  Thumb,
  Viewport
} from '@radix-ui/react-scroll-area';
import clsx from 'clsx';

import styles from './ScrollView.module.css';

type Classes = Partial<{
  children: string;
  viewport: string;
  root: string;
  scrollbar: string;
  thumb: string;
  corner: string;
}>;

interface ScrollView {
  children: JSX.Element;
  classes: Classes;
  style?: React.CSSProperties;
}

export const ScrollView = forwardRef<HTMLDivElement, ScrollView>(
  ({ children, classes }, ref) => (
    <Root className={clsx(styles.root, classes?.root || '')}>
      <Viewport className={clsx(styles.viewport, classes?.viewport || '')}>
        <div ref={ref} className={classes?.children ?? ''}>
          {children}
        </div>
      </Viewport>
      <Scrollbar
        orientation='vertical'
        className={clsx(styles.scrollbar, classes?.scrollbar)}
      >
        <Thumb className={clsx(styles.thumb, classes?.thumb)} />
      </Scrollbar>
      <Scrollbar
        orientation='horizontal'
        className={clsx(styles.scrollbar, classes?.scrollbar)}
      >
        <Thumb className={clsx(styles.thumb, classes?.thumb)} />
      </Scrollbar>
      <Corner className={clsx(styles.corner, classes?.corner)} />
    </Root>
  )
);

ScrollView.displayName = 'ScrollView';
